import _extends from "@babel/runtime/helpers/extends";
import React, { createContext, useContext } from 'react';
var noop = function noop() {};
export var SwitcherExperienceTrackerContext = /*#__PURE__*/createContext({
  start: noop,
  success: noop,
  failure: noop,
  failureAll: noop,
  abort: noop,
  abortAll: noop,
  markStart: noop,
  markEnd: noop
});
export var useExperienceTracker = function useExperienceTracker() {
  return useContext(SwitcherExperienceTrackerContext);
};
export var withExperienceTracker = function withExperienceTracker(Component) {
  var WithExperienceTracker = function WithExperienceTracker(props) {
    var experienceTracker = useExperienceTracker();
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      experienceTracker: experienceTracker
    }));
  };
  WithExperienceTracker.displayName = "WithExperienceTracker(".concat(Component.displayName, ")");
  return WithExperienceTracker;
};